import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";

const ProtectedRoutes = ({ userType, roles, children }) => {
  return userType && roles && roles.includes(userType) ? (
    children
  ) : (
    <Navigate to="/unautorized" />
  );
};

const PrivateRoutes = ({ children, roles }) => {
  let token = localStorage.getItem("token");
  let email = localStorage.getItem("email");
  let userType = localStorage.getItem("userType");

  return token && email ? (
    <ProtectedRoutes userType={userType} roles={roles}>
      {children}
    </ProtectedRoutes>
  ) : (
    <Navigate to="/login" />
  );
};

export default PrivateRoutes;

export const roles = ["2", "3"];
